import axios from "axios";

const request = (graphql, isJSON, service) => {
  const configRequest = {
    method: graphql ? "post" : service.method,
    credentials: "same-origin",
    "Access-Control-Allow-Origin": "*",
    headers: Object.assign(
      isJSON && !service.formData
        ? {
            Accept: "application/json",
            "Content-Type": "application/json",
          }
        : {},
      service.headers
    ),
    url: graphql ? "/api/graphql" : service.route,
    data: service.data,
  };

  if (
    !graphql &&
    (service.method === "post" || service.method === "put" || service.method === "patch")
  ) {
    configRequest.data = isJSON && !service.formData ? JSON.stringify(service.data) : service.data;
  }
  return axios(configRequest.url, configRequest)
    .then((response) => response)
    .catch((error) => {
      throw error;
    });
};

export const requestGraphQL = (...requestProps) => request(true, true, ...requestProps);
export const requestApi = (...requestProps) => request(false, true, ...requestProps);
